import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--dismiss"
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 }, // Auto-dismiss after N milliseconds (0 = no auto-dismiss)
    animation: { type: String, default: "fade" } // fade, slide, none
  }

  connect() {
    if (this.delayValue > 0) {
      this.autoDismissTimeout = setTimeout(() => {
        this.remove()
      }, this.delayValue)
    }
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  remove(event) {
    event?.preventDefault()

    if (this.animationValue === "none") {
      this.element.remove()
      return
    }

    // Add exit animation
    if (this.animationValue === "slide") {
      this.element.style.transition = "transform 200ms ease-out, opacity 200ms ease-out"
      this.element.style.transform = "translateX(100%)"
      this.element.style.opacity = "0"
    } else {
      // Default fade animation
      this.element.style.transition = "opacity 150ms ease-out"
      this.element.style.opacity = "0"
    }

    // Remove after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
